import React from "react";
import LiveWaitingIndicator from "./components/shared/LiveWaitingIndicator";
import { Text } from "@merge-api/merge-javascript-shared";

interface DashboardOnboardingNavDropdownProps {
  toggled?: boolean;
  icon: React.ReactNode;
  text: React.ReactNode;
}

const DashboardOnboardingNavDropdown: React.FC<DashboardOnboardingNavDropdownProps> = ({
  toggled,
  icon,
  text,
}) => (
  <div className="flex items-center justify-start gap-x-3 my-1">
    {icon && <span>{icon}</span>}
    <Text>{text}</Text>
    {toggled !== undefined && <LiveWaitingIndicator color={toggled ? "green" : "red"} />}
  </div>
);

export default DashboardOnboardingNavDropdown;
